import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup, AbstractControl, UntypedFormControl, UntypedFormArray} from '@angular/forms';
import {FormBuilderService} from './services/form-builder.service';
import {LookupService} from './services/lookup.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import {TypesService} from './services/types.service';
import {ClientService} from './services/client.service';
import {FmcLibraryNotificationService} from './services/notification.service';
import {BankingService} from './services/banking.service';
import {CollateralService} from './services/collateral.service';
import { MatDialog } from '@angular/material/dialog';
import { CommunicationsService } from './services/communications.service';

@Component({
  selector: 'fmc-elements',
  template: `Child forms are going to inherit this`,
  styles: []
})
export class FmcElementsComponent implements OnInit {
  @Input() public placeholderText: string;
  @Input() public controlName: string;
  @Input() public activeLook: string;
  @Input() public parentFormGroup: UntypedFormGroup;
  @Input() public required = false;
  @Input() public notRequired = false;
  @Input() public validators = [];
  @Input() public asyncValidators = [];
  @Input() public readonly = false;
  @Input() public disable = false;
  @Input() public tabindex: string;

  public defaultControl: AbstractControl;
  public formGroup: UntypedFormGroup;
  public formArray: UntypedFormArray;
  public formControl: UntypedFormControl;
  public defaultControlType: String;

  public startRender = false;

  constructor(public formBuilderService: FormBuilderService,
              public collateralService: CollateralService,
              public bankingService: BankingService,
              public lookupService: LookupService,
              public typesService: TypesService,
              public clientService: ClientService,
              public notificationService: FmcLibraryNotificationService,
              public communicationsService: CommunicationsService,
              public dialog: MatDialog,
              public snackBar: MatSnackBar) {
    this.notificationService.notificationAlert.subscribe(next => {
      if (next.type === 'success') {
        this.snackBar.open(next.message, next.title, {
          duration: 5000,
          panelClass: ['success-snackbar']
        });
      } else if (next.type === 'warn') {
        this.snackBar.open(next.message, next.title, {
          duration: 5000,
          panelClass: ['warn-snackbar']
        });
      } else if (next.type === 'error') {
        this.snackBar.open(next.message, next.title, {
          duration: 5000,
          panelClass: ['error-snackbar']
        });
      } else {
        this.snackBar.open(next.message, next.title, {
          duration: 5000,
        });
      }
    });
  }

  ngOnInit() {
    if (!this.defaultControl) {
      console.error('ERROR: FMC Component must have a default control');
      return;
    }

    // console.log('NOT EXISTS', !this.parentFormGroup.get(this.controlName));

    if (this.parentFormGroup && !this.parentFormGroup.get(this.controlName)) {
      this.parentFormGroup.addControl(this.controlName, this.defaultControl);
    }

    if (this.defaultControlType === 'FormGroup') {
      if (this.parentFormGroup.get(this.controlName)) {
        // make sure the formcontrol alludes to the proper formGroup
        const value = this.parentFormGroup.get(this.controlName).value;
        this.parentFormGroup.setControl(this.controlName, this.defaultControl);
        if (value) {
          this.parentFormGroup.get(this.controlName).patchValue(value);
        }
      }
      this.formGroup = this.parentFormGroup.get(this.controlName) as UntypedFormGroup;
    } else if (this.defaultControlType === 'FormControl') {
      this.formGroup = this.parentFormGroup;
      this.formControl = this.parentFormGroup.get(this.controlName) as UntypedFormControl;
    } else if (this.defaultControlType === 'FormArray') {
      this.formGroup = this.parentFormGroup;
      this.formArray = this.parentFormGroup.get(this.controlName) as UntypedFormArray;
    } else {
      this.formGroup = this.parentFormGroup;
      this.formControl = this.parentFormGroup.get(this.controlName) as UntypedFormControl;
    }

    // console.log('FMC library control created', this.controlName, this.formGroup);
    this.startRender = true;
    this.addValidators();
  }

  /**
   * Override the implementation if needed
   */
  addValidators() {
    if (this.validators && this.validators.length > 0) {
      this.formGroup.get(this.controlName).setValidators(this.validators);
    }

    if (this.asyncValidators && this.asyncValidators.length > 0) {
      this.formGroup.get(this.controlName).setAsyncValidators(this.asyncValidators);
    }
  }

}
